import classNames from 'classnames/bind';
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <div className={cx('footer')}>
      <a
        href="https://www.dfinsolutions.com/privacy-notice"
        className={cx('footer__link')}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
      <span className={cx('footer__separator')}>|</span>
      <a
        href="https://www.dfinsolutions.com/notice-collection"
        className={cx('footer__link')}
        target="_blank"
        rel="noreferrer"
      >
        Notice at Collection
      </a>
    </div>
  );
};

export default Footer;
